// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Campaign/';
export const CampaignActionTypes = {
  CAMPAIGNBANNER: ActionHelper.createActionTypes(
    actionTypePrefix,
    'CAMPAIGNBANNER'
  ),
};
